<app-modal-frame [headerText]="CONST.HEADER" [hasHeaderCloseButton]="false">
  <div class="confirm-end-scan-modal">
    <div class="confirm-end-scan-modal-body">
      <div class="message">{{ CONST.MOVEMENT }}: {{ data.movement }}</div>
      <div class="message">{{ CONST.DEPART_DATE }}: {{ data.departDate }}</div>
    </div>
    <ion-row class="ion-justify-content-between">
      <ion-button
        class="back-btn"
        fill="outline"
        (click)="dialogRef.close()"
        onkeypress="dialogRef.close()"
      >
        {{ CONST.BACK }}
      </ion-button>
      <ion-button
        class="end-btn"
        (click)="endOutboundScan()"
        onkeypress="endOutboundScan()"
      >
        {{ CONST.END }}
      </ion-button>
    </ion-row>
  </div>
</app-modal-frame>
